/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as GetOfferDetailsImport } from './routes/get-offer-details'
import { Route as BuildDocumentsImport } from './routes/build-documents'
import { Route as IndexImport } from './routes/index'
import { Route as ImportProfileIndexImport } from './routes/import-profile/index'
import { Route as ImportProfileEditProfileImport } from './routes/import-profile/edit-profile'
import { Route as ImportProfileMethodImport } from './routes/import-profile/$method'

// Create/Update Routes

const GetOfferDetailsRoute = GetOfferDetailsImport.update({
  id: '/get-offer-details',
  path: '/get-offer-details',
  getParentRoute: () => rootRoute,
} as any)

const BuildDocumentsRoute = BuildDocumentsImport.update({
  id: '/build-documents',
  path: '/build-documents',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const ImportProfileIndexRoute = ImportProfileIndexImport.update({
  id: '/import-profile/',
  path: '/import-profile/',
  getParentRoute: () => rootRoute,
} as any)

const ImportProfileEditProfileRoute = ImportProfileEditProfileImport.update({
  id: '/import-profile/edit-profile',
  path: '/import-profile/edit-profile',
  getParentRoute: () => rootRoute,
} as any)

const ImportProfileMethodRoute = ImportProfileMethodImport.update({
  id: '/import-profile/$method',
  path: '/import-profile/$method',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/build-documents': {
      id: '/build-documents'
      path: '/build-documents'
      fullPath: '/build-documents'
      preLoaderRoute: typeof BuildDocumentsImport
      parentRoute: typeof rootRoute
    }
    '/get-offer-details': {
      id: '/get-offer-details'
      path: '/get-offer-details'
      fullPath: '/get-offer-details'
      preLoaderRoute: typeof GetOfferDetailsImport
      parentRoute: typeof rootRoute
    }
    '/import-profile/$method': {
      id: '/import-profile/$method'
      path: '/import-profile/$method'
      fullPath: '/import-profile/$method'
      preLoaderRoute: typeof ImportProfileMethodImport
      parentRoute: typeof rootRoute
    }
    '/import-profile/edit-profile': {
      id: '/import-profile/edit-profile'
      path: '/import-profile/edit-profile'
      fullPath: '/import-profile/edit-profile'
      preLoaderRoute: typeof ImportProfileEditProfileImport
      parentRoute: typeof rootRoute
    }
    '/import-profile/': {
      id: '/import-profile/'
      path: '/import-profile'
      fullPath: '/import-profile'
      preLoaderRoute: typeof ImportProfileIndexImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/build-documents': typeof BuildDocumentsRoute
  '/get-offer-details': typeof GetOfferDetailsRoute
  '/import-profile/$method': typeof ImportProfileMethodRoute
  '/import-profile/edit-profile': typeof ImportProfileEditProfileRoute
  '/import-profile': typeof ImportProfileIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/build-documents': typeof BuildDocumentsRoute
  '/get-offer-details': typeof GetOfferDetailsRoute
  '/import-profile/$method': typeof ImportProfileMethodRoute
  '/import-profile/edit-profile': typeof ImportProfileEditProfileRoute
  '/import-profile': typeof ImportProfileIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/build-documents': typeof BuildDocumentsRoute
  '/get-offer-details': typeof GetOfferDetailsRoute
  '/import-profile/$method': typeof ImportProfileMethodRoute
  '/import-profile/edit-profile': typeof ImportProfileEditProfileRoute
  '/import-profile/': typeof ImportProfileIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/build-documents'
    | '/get-offer-details'
    | '/import-profile/$method'
    | '/import-profile/edit-profile'
    | '/import-profile'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/build-documents'
    | '/get-offer-details'
    | '/import-profile/$method'
    | '/import-profile/edit-profile'
    | '/import-profile'
  id:
    | '__root__'
    | '/'
    | '/build-documents'
    | '/get-offer-details'
    | '/import-profile/$method'
    | '/import-profile/edit-profile'
    | '/import-profile/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BuildDocumentsRoute: typeof BuildDocumentsRoute
  GetOfferDetailsRoute: typeof GetOfferDetailsRoute
  ImportProfileMethodRoute: typeof ImportProfileMethodRoute
  ImportProfileEditProfileRoute: typeof ImportProfileEditProfileRoute
  ImportProfileIndexRoute: typeof ImportProfileIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BuildDocumentsRoute: BuildDocumentsRoute,
  GetOfferDetailsRoute: GetOfferDetailsRoute,
  ImportProfileMethodRoute: ImportProfileMethodRoute,
  ImportProfileEditProfileRoute: ImportProfileEditProfileRoute,
  ImportProfileIndexRoute: ImportProfileIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/build-documents",
        "/get-offer-details",
        "/import-profile/$method",
        "/import-profile/edit-profile",
        "/import-profile/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/build-documents": {
      "filePath": "build-documents.tsx"
    },
    "/get-offer-details": {
      "filePath": "get-offer-details.tsx"
    },
    "/import-profile/$method": {
      "filePath": "import-profile/$method.tsx"
    },
    "/import-profile/edit-profile": {
      "filePath": "import-profile/edit-profile.tsx"
    },
    "/import-profile/": {
      "filePath": "import-profile/index.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
